import type {ReactElement} from 'react';
import {Button, ButtonType, ButtonSize} from '@Components/button';
import {useAiChatCallbacks} from '@AiChat/callbacks/ai-chat-callbacks.context';
import type {UseThisButtonProps} from './use-this-button.types';

export function UseThisButton({asset}: UseThisButtonProps): ReactElement {
  const {onUseAsset} = useAiChatCallbacks();

  if (!onUseAsset) {
    return <></>;
  }

  return (
    <Button
      text={window.i18next.t('pmwjs_use_this')}
      icon="icon-check"
      type={ButtonType.PRIMARY}
      size={ButtonSize.SMALL}
      customClasses="radius-8"
      textClasses="_text-transform-none"
      onClick={(): void => {
        onUseAsset(asset);
      }}
    />
  );
}
